export default __webpack_public_path__ + "static/media/landing.df4e9aac.svg";